import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Badge, Link, makeStyles, Paper, Typography, withStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    button: {
        width: 130,
        height: 130,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'

    },
    buttonIcon: {
        width: 45,
        height: 45,
        marginTop: 15,
        marginBottom: 10
    },
    buttonLabel: {
        color: theme.palette.secondary.main,
        fontSize: 22,
        fontWeight: 'bold',
        height: 52,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '90%',
        lineHeight: 1.2,
        textDecoration: 'none'
    }
}));

const StyledBadge = withStyles((theme) => ({
    badge: {
        top: 13,
    },
}))(Badge);

const DashboardButton = props => {
    const classes = useStyles();

    return (
        <Link component={RouterLink} to={props.linkPath} target={props.target}>
            <Paper className={classes.button}>
                {props.pending
                    ? <StyledBadge badgeContent="!" color="error">
                        {props.iconComponent}
                    </StyledBadge>
                    : props.isNotification ?
                        <StyledBadge badgeContent={props.notificationCount} color="error">
                            {props.iconComponent}
                        </StyledBadge> : <>{props.iconComponent}</>
                }
                <Typography className={classes.buttonLabel}>{props.label}</Typography>
            </Paper>
        </Link >
    );
};

export default DashboardButton;